// extracted by mini-css-extract-plugin
module.exports = {"willManager__main":"styles_willManager__main__83lmg","willList":"styles_willList__I1Lg3"};